var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2H6.13239C5.42986 2 4.77885 2.3686 4.4174 2.97101L2.45001 6.25H11.25V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.25V2H17.8676C18.5701 2 19.2212 2.3686 19.5826 2.97101L21.55 6.25H12.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V7.75H2ZM10.75 11.5V13.1622H15C15.5523 13.1622 16 13.5978 16 14.1351V18.027C16 18.5644 15.5523 19 15 19H9C8.44772 19 8 18.5644 8 18.027V14.1351C8 13.5978 8.44772 13.1622 9 13.1622H9.25V11.5C9.25 10.5335 10.0335 9.75 11 9.75H13C13.9665 9.75 14.75 10.5335 14.75 11.5C14.75 11.9142 14.4142 12.25 14 12.25C13.5858 12.25 13.25 11.9142 13.25 11.5C13.25 11.3619 13.1381 11.25 13 11.25H11C10.8619 11.25 10.75 11.3619 10.75 11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox6);
export default __webpack_public_path__ + "static/media/box-6.bc60e7d98716d34859f94a9adfa4afbe.svg";
export { ForwardRef as ReactComponent };